import { render } from "./PrincipalGroupBindings.vue?vue&type=template&id=458dfced&scoped=true"
import script from "./PrincipalGroupBindings.vue?vue&type=script&lang=js"
export * from "./PrincipalGroupBindings.vue?vue&type=script&lang=js"

import "./PrincipalGroupBindings.vue?vue&type=style&index=0&id=458dfced&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458dfced"]])

export default __exports__